import React from 'react';
import Button from '../../../../common/Button';
import { Modal, notification } from 'antd';
import { Formik, ErrorMessage } from 'formik';
import Input from 'formik-antd/lib/input';
import Form from 'formik-antd/lib/form';
import SubmitButton from '../../../../common/SubmitButton';
import { string, object } from 'yup';
import Api from '../../../services/Api';
import {
  Flex,
  FieldError,
  openNotificationWithIcon,
} from '@mss/mss-component-library';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
type AddGroupModalProps = {
  closeModal: () => void;
};

export default function AddGroupModal({ closeModal }: AddGroupModalProps) {
  const queryClient = useQueryClient();
  const [t] = useTranslation(['authorization', 'common']);
  const history = useHistory();
  const { url } = useRouteMatch();
  return (
    <Modal
      title={t(`Add groups to this site manager`)}
      visible
      closable={false}
      footer={[
        <Button ghost variant="primary" onClick={closeModal}>
          {t('Cancel')}
        </Button>,
      ]}
    >
      <p>
        {t(
          "Enter a groupname and press 'Add' to create an empty group without any permissions. Afterwards you will be redirected to your newly created group."
        )}
      </p>
      <Formik
        onSubmit={async (values: any) => {
          const result = await Api.group.add(values);
          if (result.status >= 200 && result.status < 300) {
            const response = await result.json();
            openNotificationWithIcon(
              notification.success,
              t('Group added'),
              t('Group successfully added to the site manager.')
            );
            await queryClient.invalidateQueries({
              queryKey: ['groups'],
            });
            history.push(`${url}/${response.id}`);
          } else {
            if (result.status === 400) {
              openNotificationWithIcon(
                notification.error,
                t('Adding group failed'),
                t(
                  'The group with name (VALUESNAME) already exists and therefore could not be added to this site.',
                  { valueName: values.name }
                )
              );
            } else {
              openNotificationWithIcon(
                notification.error,
                t('Adding group failed'),
                t(
                  'Due to technical issues the group could not be added to the site. Please try again later.'
                )
              );
            }
          }
        }}
        initialValues={{ name: '' }}
        validationSchema={object().shape({
          name: string()
            .min(3, t('The name of the group has to be at least 3 characters'))
            .max(
              150,
              t('The name of the group cannot be more than 150 characters')
            )
            .required(t('Please enter group name'))
            .trim(t('Cannot start or end with whitespace'))
            .strict(true),
        })}
      >
        {({ values, errors, handleChange, handleBlur }) => {
          return (
            <Form>
              <Flex h="start" v="center">
                <Input
                  name={'name'}
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ flex: '0 1 90%' }}
                />
                <SubmitButton
                  disabled={!!errors.name || !values.name}
                  style={{ flex: '0 0 80px' }}
                >
                  {t('Add')}
                </SubmitButton>
              </Flex>
              <FieldError>
                <ErrorMessage name={'name'} />
              </FieldError>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}
